import { NextRouter, useRouter } from 'next/router';
import { GetServerSideProps } from 'next';
import APIServices from '@/apiUtils/APIServices';
import Head from 'next/head';

import dynamic from 'next/dynamic';
const LandingLayout = dynamic(() => import('@/components/landing/home/LandingLayout'));
const BlogCardContent = dynamic(() => import('@/components/landing/blog/BlogCardContent'));

function Blog(props: any) {
  const router: NextRouter = useRouter();
  return (
    <>
      <Head>
        <title>Blog List | Learnsic</title>
        <link rel="canonical" href={`${process.env.NEXT_PUBLIC_SITE_URL}blog`} />
      </Head>
      <LandingLayout>
        <BlogCardContent
          blogs={props?.data?.data}
          total={props?.data?.meta?.total}
          loading={router.isFallback}
        />
      </LandingLayout>
    </>
  );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { data, success } = await new APIServices(
    `/blog/?name=${context.query.name ? context.query.name : ''}&category=${
      context.query.category ? context.query.category : ''
    }&page=${context.query.page ? context.query.page : '1'}&per_page=${
      context.query.per_page ? context.query.per_page : '12'
    }`
  ).get();
  return {
    props: {
      data: data,
    },
  };
};

export default Blog;
